<script lang="ts" setup>
const { LocalConfigurationStore } = stores()

const heading = computed(() => LocalConfigurationStore.value?.siteInfo?.companySectionTitle)

const items = computed(() =>
  LocalConfigurationStore.value?.associatedCompanies?.filter((x) =>
    LocalConfigurationStore.value?.siteInfo?.associatedCompanies?.includes(x.code)
  )
)
</script>

<template>
  <div class="flex flex-col gap-1">
    <TitleComponent
      v-if="heading"
      :text="heading.title"
      :tagline="heading?.subTitle"
    />
    <GridComponent :cols="items?.length">
      <template
        v-for="company in items"
        :key="company.code"
      >
        <div>
          <ContentCompanyThumbnail :company />
        </div>
      </template>
    </GridComponent>
  </div>
</template>
